export const corePageContentTranslations = {
  en: {
    'core.personalMode': 'Personal Mode',
    'core.businessMode': 'Business Mode',
    'core.recentlyCreatedToken': 'Recently Created Token',
    'core.recentlyCreatedInvoice': 'Recently Created Invoice',
    'core.createAnotherToken': 'Create another',
    'core.referralTokens': 'Referral Tokens',
    'core.paymentsGuide.title': 'How payments work on Vaiu',
    'core.paymentsGuide.summary': 'Unlike picking someone inside the app, you create a payment token here and share the code or link the way you normally message people. They redeem it in Vaiu to receive funds.',
    'core.paymentsGuide.step1': 'Create a token for the amount you want to move.',
    'core.paymentsGuide.step2': 'Share it by text, email, QR, or any channel you already use.',
    'core.paymentsGuide.step3': 'The recipient can spend the token anywhere Vaiu is accepted or deposit it to their own Vaiu account.',
    'core.paymentsGuide.trustLine': 'Only redeem tokens you expected from someone you trust.',
    'core.paymentsGuide.senderCta': "I'm paying someone",
    'core.paymentsGuide.receiverCta': 'Someone sent me money',
    'core.paymentsGuide.dismiss': "Don't show again",
    'core.toast.tokenCreated': 'Token Created Successfully',
    'core.toast.tokenCreatedDesc': 'Token {{key}} created successfully!',
    'core.toast.balanceUpdated': 'Balance Updated',
    'core.toast.balanceUpdatedDesc': 'Your balance has been updated.',
    'core.toast.paypalSuccess': 'PayPal payment successful!',
    'core.toast.paypalSuccessDesc': 'Your balance has been updated. Continuing with token creation...',
    'core.toast.tokenCreatedTitle': 'Token created',
    'core.toast.tokenRedeemedTitle': 'Token redeemed',
    'core.toast.balanceToppedUpTitle': 'Balance topped up',
    'core.toast.balanceUpdatedTitle': 'Balance updated',
    'core.toast.balanceChangedDesc': '{{currency}} balance changed by {{change}}{{tokenKey}}',
  },
  es: {
    'core.personalMode': 'Modo Personal',
    'core.businessMode': 'Modo de Negocios',
    'core.recentlyCreatedToken': 'Token Creado Recientemente',
    'core.recentlyCreatedInvoice': 'Factura Creada Recientemente',
    'core.createAnotherToken': 'Crear otro',
    'core.referralTokens': 'Tokens de Referencia',
    'core.paymentsGuide.title': 'Cómo funcionan los pagos en Vaiu',
    'core.paymentsGuide.summary': 'En lugar de elegir a alguien dentro de la app, creas un token de pago aquí y compartes el código o enlace como cualquier mensaje. La otra persona lo canjea en Vaiu para recibir los fondos.',
    'core.paymentsGuide.step1': 'Crea un token por el monto que quieres mover.',
    'core.paymentsGuide.step2': 'Compártelo por SMS, correo, QR o el canal que ya uses.',
    'core.paymentsGuide.step3': 'El destinatario puede gastar el token donde se acepte Vaiu o depositarlo en su propia cuenta Vaiu.',
    'core.paymentsGuide.trustLine': 'Solo canjea tokens que esperabas de alguien de confianza.',
    'core.paymentsGuide.senderCta': 'Voy a pagar a alguien',
    'core.paymentsGuide.receiverCta': 'Alguien me envió dinero',
    'core.paymentsGuide.dismiss': 'No volver a mostrar',
    'core.toast.tokenCreated': '¡Token Creado Exitosamente!',
    'core.toast.tokenCreatedDesc': '¡El token {{key}} se creó exitosamente!',
    'core.toast.balanceUpdated': 'Saldo Actualizado',
    'core.toast.balanceUpdatedDesc': 'Tu saldo ha sido actualizado.',
    'core.toast.paypalSuccess': '¡Pago de PayPal exitoso!',
    'core.toast.paypalSuccessDesc': 'Tu saldo ha sido actualizado. Continuando con la creación del token...',
    'core.toast.tokenCreatedTitle': 'Token creado',
    'core.toast.tokenRedeemedTitle': 'Token canjeado',
    'core.toast.balanceToppedUpTitle': 'Saldo recargado',
    'core.toast.balanceUpdatedTitle': 'Saldo actualizado',
    'core.toast.balanceChangedDesc': 'El saldo de {{currency}} cambió en {{change}}{{tokenKey}}',
  },
  fr: {
    'core.personalMode': 'Mode personnel',
    'core.businessMode': 'Mode entreprise',
    'core.recentlyCreatedToken': 'Token créé récemment',
    'core.recentlyCreatedInvoice': 'Facture créée récemment',
    'core.createAnotherToken': 'Créer un autre',
    'core.referralTokens': 'Tokens de parrainage',
    'core.paymentsGuide.title': 'Comment fonctionnent les paiements sur Vaiu',
    'core.paymentsGuide.summary': 'Plutôt que de choisir quelqu’un dans l’app, vous créez un jeton de paiement ici et partagez le code ou le lien comme un message. L’autre personne l’échange dans Vaiu pour recevoir les fonds.',
    'core.paymentsGuide.step1': 'Créez un jeton pour le montant à transférer.',
    'core.paymentsGuide.step2': 'Partagez-le par SMS, e-mail, QR ou tout canal habituel.',
    'core.paymentsGuide.step3': 'Le destinataire peut utiliser le jeton partout où Vaiu est accepté ou le déposer sur son propre compte Vaiu.',
    'core.paymentsGuide.trustLine': 'N’échangez que des jetons attendus, provenant de personnes de confiance.',
    'core.paymentsGuide.senderCta': 'Je paie quelqu’un',
    'core.paymentsGuide.receiverCta': 'On m’a envoyé de l’argent',
    'core.paymentsGuide.dismiss': 'Ne plus afficher',
    'core.toast.tokenCreated': 'Token créé avec succès',
    'core.toast.tokenCreatedDesc': 'Le token {{key}} a été créé avec succès !',
    'core.toast.balanceUpdated': 'Solde mis à jour',
    'core.toast.balanceUpdatedDesc': 'Votre solde a été mis à jour.',
    'core.toast.paypalSuccess': 'Paiement PayPal réussi !',
    'core.toast.paypalSuccessDesc': 'Votre solde a été mis à jour. Poursuite de la création du token...',
    'core.toast.tokenCreatedTitle': 'Token créé',
    'core.toast.tokenRedeemedTitle': 'Token échangé',
    'core.toast.balanceToppedUpTitle': 'Solde rechargé',
    'core.toast.balanceUpdatedTitle': 'Solde mis à jour',
    'core.toast.balanceChangedDesc': 'Le solde {{currency}} a changé de {{change}}{{tokenKey}}',
  },
  sq: {
    'core.personalMode': 'Modalitet Personal',
    'core.businessMode': 'Modalitet Biznesi',
    'core.recentlyCreatedToken': 'Token i Krijuar Së Fundmi',
    'core.recentlyCreatedInvoice': 'Faturë e Krijuar Së Fundmi',
    'core.createAnotherToken': 'Krijo një tjetër',
    'core.referralTokens': 'Tokenat e Referimit',
    'core.paymentsGuide.title': 'Si funksionojnë pagesat në Vaiu',
    'core.paymentsGuide.summary': 'Në vend që të zgjidhni dikë brenda aplikacionit, krijoni një token pagese këtu dhe ndani kodin ose lidhjen si çdo mesazh. Tjetri e shkëmbejnë në Vaiu për të marrë fondet.',
    'core.paymentsGuide.step1': 'Krijoni një token për shumën që dëshironi të lëvizni.',
    'core.paymentsGuide.step2': 'Ndaje me SMS, email, QR ose kanalin që përdorni.',
    'core.paymentsGuide.step3': 'Marrësi mund ta përdorë tokenin kudo që pranohet Vaiu ose ta depozitojë në llogarinë e vet Vaiu.',
    'core.paymentsGuide.trustLine': 'Shkëmbej vetëm tokena që prisnit nga dikush i besuar.',
    'core.paymentsGuide.senderCta': 'Po paguaj dikë',
    'core.paymentsGuide.receiverCta': 'Dikush më dërgoi para',
    'core.paymentsGuide.dismiss': 'Mos e shfaq më',
    'core.toast.tokenCreated': 'Tokeni u Krijua me Sukses',
    'core.toast.tokenCreatedDesc': 'Tokeni {{key}} u krijua me sukses!',
    'core.toast.balanceUpdated': 'Bilanci u Përditësua',
    'core.toast.balanceUpdatedDesc': 'Bilanci juaj është përditësuar.',
    'core.toast.paypalSuccess': 'Pagesa PayPal e suksesshme!',
    'core.toast.paypalSuccessDesc': 'Bilanci juaj është përditësuar. Duke vazhduar me krijimin e tokenit...',
    'core.toast.tokenCreatedTitle': 'Tokeni u krijua',
    'core.toast.tokenRedeemedTitle': 'Tokeni u shkëmbye',
    'core.toast.balanceToppedUpTitle': 'Bilanci u rimbush',
    'core.toast.balanceUpdatedTitle': 'Bilanci u përditësua',
    'core.toast.balanceChangedDesc': 'Bilanci {{currency}} ndryshoi me {{change}}{{tokenKey}}',
  },
  ru: {
    'core.personalMode': 'Личный режим',
    'core.businessMode': 'Бизнес-режим',
    'core.recentlyCreatedToken': 'Недавно созданный токен',
    'core.recentlyCreatedInvoice': 'Недавно созданный счет',
    'core.createAnotherToken': 'Создать ещё',
    'core.referralTokens': 'Реферальные токены',
    'core.paymentsGuide.title': 'Как работают платежи в Vaiu',
    'core.paymentsGuide.summary': 'Вместо выбора получателя внутри приложения вы создаёте платёжный токен и делитесь кодом или ссылкой как обычным сообщением. Получатель обменивает его в Vaiu.',
    'core.paymentsGuide.step1': 'Создайте токен на нужную сумму.',
    'core.paymentsGuide.step2': 'Отправьте его в SMS, почте, QR или любом привычном канале.',
    'core.paymentsGuide.step3': 'Получатель может потратить токен там, где принимают Vaiu, или зачислить средства на свой счёт Vaiu.',
    'core.paymentsGuide.trustLine': 'Обменивайте только те токены, которых вы ожидали от доверенных людей.',
    'core.paymentsGuide.senderCta': 'Я плачу кому‑то',
    'core.paymentsGuide.receiverCta': 'Мне отправили деньги',
    'core.paymentsGuide.dismiss': 'Больше не показывать',
    'core.toast.tokenCreated': 'Токен успешно создан',
    'core.toast.tokenCreatedDesc': 'Токен {{key}} успешно создан!',
    'core.toast.balanceUpdated': 'Баланс обновлен',
    'core.toast.balanceUpdatedDesc': 'Ваш баланс был обновлен.',
    'core.toast.paypalSuccess': 'Оплата PayPal успешна!',
    'core.toast.paypalSuccessDesc': 'Ваш баланс был обновлен. Продолжение создания токена...',
    'core.toast.tokenCreatedTitle': 'Токен создан',
    'core.toast.tokenRedeemedTitle': 'Токен погашен',
    'core.toast.balanceToppedUpTitle': 'Баланс пополнен',
    'core.toast.balanceUpdatedTitle': 'Баланс обновлен',
    'core.toast.balanceChangedDesc': 'Баланс {{currency}} изменился на {{change}}{{tokenKey}}',
  },

  de: {
    'core.personalMode': 'Persönlicher Modus',
    'core.businessMode': 'Geschäftsmodus',
    'core.recentlyCreatedToken': 'Kürzlich erstellter Token',
    'core.recentlyCreatedInvoice': 'Kürzlich erstellte Rechnung',
    'core.createAnotherToken': 'Weiteren erstellen',
    'core.referralTokens': 'Empfehlungs-Tokens',
    'core.paymentsGuide.title': 'So funktionieren Zahlungen bei Vaiu',
    'core.paymentsGuide.summary': 'Statt jemanden in der App auszuwählen, erstellen Sie hier einen Zahlungs-Token und teilen Code oder Link wie eine normale Nachricht. Die andere Person löst ihn in Vaiu ein.',
    'core.paymentsGuide.step1': 'Erstellen Sie einen Token für den gewünschten Betrag.',
    'core.paymentsGuide.step2': 'Teilen Sie ihn per SMS, E-Mail, QR oder einem Kanal Ihrer Wahl.',
    'core.paymentsGuide.step3': 'Der Empfänger kann den Token überall ausgeben, wo Vaiu akzeptiert wird, oder auf sein eigenes Vaiu-Konto einzahlen.',
    'core.paymentsGuide.trustLine': 'Lösen Sie nur Token ein, die Sie von vertrauenswürdigen Personen erwartet haben.',
    'core.paymentsGuide.senderCta': 'Ich zahle jemandem',
    'core.paymentsGuide.receiverCta': 'Jemand hat mir Geld gesendet',
    'core.paymentsGuide.dismiss': 'Nicht mehr anzeigen',
    'core.toast.tokenCreated': 'Token erfolgreich erstellt',
    'core.toast.tokenCreatedDesc': 'Token {{key}} wurde erfolgreich erstellt!',
    'core.toast.balanceUpdated': 'Guthaben aktualisiert',
    'core.toast.balanceUpdatedDesc': 'Ihr Guthaben wurde aktualisiert.',
    'core.toast.paypalSuccess': 'PayPal-Zahlung erfolgreich!',
    'core.toast.paypalSuccessDesc': 'Ihr Guthaben wurde aktualisiert. Fortsetzung der Token-Erstellung...',
    'core.toast.tokenCreatedTitle': 'Token erstellt',
    'core.toast.tokenRedeemedTitle': 'Token eingelöst',
    'core.toast.balanceToppedUpTitle': 'Guthaben aufgeladen',
    'core.toast.balanceUpdatedTitle': 'Guthaben aktualisiert',
    'core.toast.balanceChangedDesc': '{{currency}} Guthaben geändert um {{change}}{{tokenKey}}',
  },

  sr: {
    'core.personalMode': 'Лични режим',
    'core.businessMode': 'Пословни режим',
    'core.recentlyCreatedToken': 'Недавно креиран токен',
    'core.recentlyCreatedInvoice': 'Недавно креирана фактура',
    'core.createAnotherToken': 'Креирај још један',
    'core.referralTokens': 'Реферални токени',
    'core.paymentsGuide.title': 'Како функционишу плаћања на Vaiu',
    'core.paymentsGuide.summary': 'Уместо да бирате неког у апликацији, овде креирате токен за плаћање и делите кôд или везу као поруку. Друга страна га откупи у Vaiu.',
    'core.paymentsGuide.step1': 'Направите токен за износ који желите да пошаљете.',
    'core.paymentsGuide.step2': 'Поделите га СМС-ом, имејлом, QR кôдом или каналом који већ користите.',
    'core.paymentsGuide.step3': 'Primalac može da potroši token gde god se Vaiu prihvata ili da ga položi na sopstveni Vaiu nalog.',
    'core.paymentsGuide.trustLine': 'Откупљујте само токене које сте очекивали од поузданих људи.',
    'core.paymentsGuide.senderCta': 'Плаћам некоме',
    'core.paymentsGuide.receiverCta': 'Неко ми је послао новац',
    'core.paymentsGuide.dismiss': 'Не приказуј поново',
    'core.toast.tokenCreated': 'Токен је успешно креиран!',
    'core.toast.tokenCreatedDesc': 'Токен {{key}} је успешно креиран!',
    'core.toast.balanceUpdated': 'Стање ажурирано',
    'core.toast.balanceUpdatedDesc': 'Ваше стање је ажурирано.',
    'core.toast.paypalSuccess': 'ПаиПал уплата успешна!',
    'core.toast.paypalSuccessDesc': 'Ваше стање је ажурирано. Наставља се са креирањем токена...',
    'core.toast.tokenCreatedTitle': 'Токен креиран',
    'core.toast.tokenRedeemedTitle': 'Токен искоришћен',
    'core.toast.balanceToppedUpTitle': 'Стање попуњено',
    'core.toast.balanceUpdatedTitle': 'Стање ажурирано',
    'core.toast.balanceChangedDesc': '{{currency}} стање се променило за {{change}}{{tokenKey}}',
  },
  pl: {
    'core.personalMode': 'Tryb Osobisty',
    'core.businessMode': 'Tryb Biznesowy',
    'core.recentlyCreatedToken': 'Ostatnio Utworzony Token',
    'core.recentlyCreatedInvoice': 'Ostatnio Utworzona Faktura',
    'core.createAnotherToken': 'Utwórz kolejny',
    'core.referralTokens': 'Tokeny Polecające',
    'core.paymentsGuide.title': 'Jak działają płatności w Vaiu',
    'core.paymentsGuide.summary': 'Zamiast wybierać odbiorcę w aplikacji, tworzysz tutaj token płatności i udostępniasz kod lub link jak zwykłą wiadomość. Druga osoba realizuje go w Vaiu.',
    'core.paymentsGuide.step1': 'Utwórz token na kwotę, którą chcesz przesłać.',
    'core.paymentsGuide.step2': 'Udostępnij go przez SMS, e-mail, QR lub znany kanał.',
    'core.paymentsGuide.step3': 'Odbiorca może wydać token wszędzie, gdzie akceptowany jest Vaiu, lub wpłacić go na własne konto Vaiu.',
    'core.paymentsGuide.trustLine': 'Realizuj tylko tokeny, których się spodziewałeś od zaufanych osób.',
    'core.paymentsGuide.senderCta': 'Płacę komuś',
    'core.paymentsGuide.receiverCta': 'Ktoś przysłał mi pieniądze',
    'core.paymentsGuide.dismiss': 'Nie pokazuj ponownie',
    'core.toast.tokenCreated': 'Token Utworzony Pomyślnie',
    'core.toast.tokenCreatedDesc': 'Token {{key}} został pomyślnie utworzony!',
    'core.toast.balanceUpdated': 'Saldo Zaktualizowane',
    'core.toast.balanceUpdatedDesc': 'Twoje saldo zostało zaktualizowane.',
    'core.toast.paypalSuccess': 'Płatność PayPal zakończona sukcesem!',
    'core.toast.paypalSuccessDesc': 'Twoje saldo zostało zaktualizowane. Kontynuowanie tworzenia tokena...',
    'core.toast.tokenCreatedTitle': 'Token utworzony',
    'core.toast.tokenRedeemedTitle': 'Token zrealizowany',
    'core.toast.balanceToppedUpTitle': 'Saldo doładowane',
    'core.toast.balanceUpdatedTitle': 'Saldo zaktualizowane',
    'core.toast.balanceChangedDesc': 'Saldo {{currency}} zmienione o {{change}}{{tokenKey}}',
  },
  el: {
    'core.personalMode': 'Προσωπική Λειτουργία',
    'core.businessMode': 'Επαγγελματική Λειτουργία',
    'core.recentlyCreatedToken': 'Πρόσφατα Δημιουργημένο Διακριτικό',
    'core.recentlyCreatedInvoice': 'Πρόσφατα Δημιουργημένη Τιμολόγηση',
    'core.createAnotherToken': 'Δημιουργία άλλου',
    'core.referralTokens': 'Διακριτικά Παραπομπής',
    'core.paymentsGuide.title': 'Πώς λειτουργούν οι πληρωμές στο Vaiu',
    'core.paymentsGuide.summary': 'Αντί να επιλέγετε κάποιον μέσα στην εφαρμογή, δημιουργείτε ένα διακριτικό πληρωμής και μοιράζεστε τον κώδικα ή τον σύνδεσμο σαν συνηθισμένο μήνυμα. Ο άλλος το εξαργυρώνει στο Vaiu.',
    'core.paymentsGuide.step1': 'Δημιουργήστε διακριτικό για το ποσό που θέλετε να στείλετε.',
    'core.paymentsGuide.step2': 'Μοιραστείτε το με SMS, email, QR ή κανάλι που ήδη χρησιμοποιείτε.',
    'core.paymentsGuide.step3': 'Ο παραλήπτης μπορεί να ξοδέψει το διακριτικό όπου γίνεται αποδεκτό το Vaiu ή να το καταθέσει στον προσωπικό του λογαριασμό Vaiu.',
    'core.paymentsGuide.trustLine': 'Εξαργυρώστε μόνο διακριτικά που περιμένατε από άτομα που εμπιστεύεστε.',
    'core.paymentsGuide.senderCta': 'Πληρώνω κάποιον',
    'core.paymentsGuide.receiverCta': 'Κάποιος μου έστειλε χρήματα',
    'core.paymentsGuide.dismiss': 'Να μην εμφανιστεί ξανά',
    'core.toast.tokenCreated': 'Το Διακριτικό Δημιουργήθηκε με Επιτυχία',
    'core.toast.tokenCreatedDesc': 'Το διακριτικό {{key}} δημιουργήθηκε με επιτυχία!',
    'core.toast.balanceUpdated': 'Το Υπόλοιπο Ενημερώθηκε',
    'core.toast.balanceUpdatedDesc': 'Το υπόλοιπό σας έχει ενημερωθεί.',
    'core.toast.paypalSuccess': 'Η πληρωμή PayPal ήταν επιτυχής!',
    'core.toast.paypalSuccessDesc': 'Το υπόλοιπό σας έχει ενημερωθεί. Συνέχιση με τη δημιουργία διακριτικού...',
    'core.toast.tokenCreatedTitle': 'Διακριτικό δημιουργήθηκε',
    'core.toast.tokenRedeemedTitle': 'Διακριτικό εξαργυρώθηκε',
    'core.toast.balanceToppedUpTitle': 'Υπόλοιπο αναπληρώθηκε',
    'core.toast.balanceUpdatedTitle': 'Υπόλοιπο ενημερώθηκε',
    'core.toast.balanceChangedDesc': 'Το υπόλοιπο {{currency}} άλλαξε κατά {{change}}{{tokenKey}}',
  },
  ro: {
    'core.personalMode': 'Mod Personal',
    'core.businessMode': 'Mod Afaceri',
    'core.recentlyCreatedToken': 'Token Creat Recent',
    'core.recentlyCreatedInvoice': 'Factură Creată Recent',
    'core.createAnotherToken': 'Creează altul',
    'core.referralTokens': 'Tokenuri de Recomandare',
    'core.paymentsGuide.title': 'Cum funcționează plățile în Vaiu',
    'core.paymentsGuide.summary': 'În loc să alegi pe cineva în aplicație, creezi un token de plată aici și trimiți codul sau linkul ca orice mesaj. Cealaltă persoană îl valorifică în Vaiu.',
    'core.paymentsGuide.step1': 'Creează un token pentru suma pe care vrei să o trimiți.',
    'core.paymentsGuide.step2': 'Distribuie-l prin SMS, e-mail, QR sau canalul obișnuit.',
    'core.paymentsGuide.step3': 'Destinatarul poate folosi tokenul oriunde este acceptat Vaiu sau îl poate depune în propriul cont Vaiu.',
    'core.paymentsGuide.trustLine': 'Valorifică doar tokenuri pe care le așteptai de la persoane de încredere.',
    'core.paymentsGuide.senderCta': 'Plătesc pe cineva',
    'core.paymentsGuide.receiverCta': 'Cineva mi-a trimis bani',
    'core.paymentsGuide.dismiss': 'Nu mai afișa',
    'core.toast.tokenCreated': 'Token Creat cu Succes',
    'core.toast.tokenCreatedDesc': 'Tokenul {{key}} a fost creat cu succes!',
    'core.toast.balanceUpdated': 'Sold Actualizat',
    'core.toast.balanceUpdatedDesc': 'Soldul dvs. a fost actualizat.',
    'core.toast.paypalSuccess': 'Plata PayPal a reușit!',
    'core.toast.paypalSuccessDesc': 'Soldul dvs. a fost actualizat. Continuare cu crearea tokenului...',
    'core.toast.tokenCreatedTitle': 'Token creat',
    'core.toast.tokenRedeemedTitle': 'Token răscumpărat',
    'core.toast.balanceToppedUpTitle': 'Sold reîncărcat',
    'core.toast.balanceUpdatedTitle': 'Sold actualizat',
    'core.toast.balanceChangedDesc': 'Soldul {{currency}} s-a schimbat cu {{change}}{{tokenKey}}',
  },
  pt: {
    'core.personalMode': 'Modo Pessoal',
    'core.businessMode': 'Modo Comercial',
    'core.recentlyCreatedToken': 'Token Criado Recentemente',
    'core.recentlyCreatedInvoice': 'Fatura Criada Recentemente',
    'core.createAnotherToken': 'Criar outro',
    'core.referralTokens': 'Tokens de Indicação',
    'core.paymentsGuide.title': 'Como funcionam os pagamentos no Vaiu',
    'core.paymentsGuide.summary': 'Em vez de escolher alguém no app, você cria um token de pagamento aqui e compartilha o código ou o link como qualquer mensagem. A outra pessoa resgata no Vaiu.',
    'core.paymentsGuide.step1': 'Crie um token para o valor que deseja enviar.',
    'core.paymentsGuide.step2': 'Compartilhe por SMS, e-mail, QR ou canal que você já usa.',
    'core.paymentsGuide.step3': 'O destinatário pode usar o token onde o Vaiu for aceito ou depositá-lo na própria conta Vaiu.',
    'core.paymentsGuide.trustLine': 'Resgate apenas tokens que você esperava de pessoas de confiança.',
    'core.paymentsGuide.senderCta': 'Vou pagar alguém',
    'core.paymentsGuide.receiverCta': 'Alguém me enviou dinheiro',
    'core.paymentsGuide.dismiss': 'Não mostrar de novo',
    'core.toast.tokenCreated': 'Token Criado com Sucesso',
    'core.toast.tokenCreatedDesc': 'Token {{key}} criado com sucesso!',
    'core.toast.balanceUpdated': 'Saldo Atualizado',
    'core.toast.balanceUpdatedDesc': 'Seu saldo foi atualizado.',
    'core.toast.paypalSuccess': 'Pagamento PayPal bem-sucedido!',
    'core.toast.paypalSuccessDesc': 'Seu saldo foi atualizado. Continuando com a criação do token...',
    'core.toast.tokenCreatedTitle': 'Token criado',
    'core.toast.tokenRedeemedTitle': 'Token resgatado',
    'core.toast.balanceToppedUpTitle': 'Saldo recarregado',
    'core.toast.balanceUpdatedTitle': 'Saldo atualizado',
    'core.toast.balanceChangedDesc': 'Saldo {{currency}} alterado em {{change}}{{tokenKey}}',
  },
};
